/* eslint no-barrel-files/no-barrel-files: off -- Alloy's synchronous dynamic transform requires direct named exports from this shared chunk. */
import {CommitEntrypoint, CommitPathEntrypoint} from './Commit'
import {CommitsEntrypoint, CommitsRefEntrypoint} from './Commits'
import {CommitsLayout} from './CommitsLayout'
import type {CommitsRouteComponents} from './create-commits-routes'

export {CommitEntrypoint, CommitPathEntrypoint, CommitsEntrypoint, CommitsLayout, CommitsRefEntrypoint}

export const commitsRouteComponents = {
  CommitsLayout,
  CommitsEntrypoint,
  CommitsRefEntrypoint,
  CommitEntrypoint,
  CommitPathEntrypoint,
} satisfies CommitsRouteComponents
